<template>
  <div>
    <DepartmentDetail type="edit" :submitting="submitting" :values="data" @submit="submit" />
  </div>
</template>

<script>
import { helper } from '@core/mixins/helper';
import DepartmentDetail from '@/views/pages/departments/DepartmentDetail.vue';
import useService from '@/auth/service/useService';

export default {
  components: {
    DepartmentDetail
  },
  mixins: [helper],

  data() {
    return {
      submitting: false,
      id: '',
      data: {}
    };
  },

  created() {
    const departmentId = this.$route.params.id;
    this.id = departmentId;
    this.getDepartmentDetail(departmentId);
  },

  methods: {
    submit(data) {
      this.submitting = true;
      useService
        .editDepartments(this.id, {
          ...data,
          status: data.status ? 1 : 0
        })
        .then(response => {
          if (response.status) {
            this.showSuccessMessage(`${response.message}`);
            this.$router.push({ name: 'department_list' });
          }
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },

    getDepartmentDetail(departmentId) {
      this.submitting = true;
      useService
        .getDepartment(departmentId)
        .then(response => {
          const {
            name,
            country: { name: country_name, id: country_id },
            address,
            status,
            priority,
            postalCode: postal_code,
            phoneNumber: phone_number,
            email,
            state: { id: state_id, name: state_name },
            city: { id: city_id, name: city_name },
            authorizedPersonName: authorized_person_name
          } = response.data;

          this.data = {
            name,
            country_id,
            address,
            status,
            priority,
            postal_code,
            phone_number,
            email,
            authorized_person_name,
            state_id,
            city_id,
            state_name,
            city_name,
            country_name
          };
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  }
};
</script>
